import Vue from "vue";
import Router from "vue-router";
import Dashboard from "@/components/Dashboard";
import Signin from "@/components/Signin";
import Activity from "@/components/Activity";
import Reports from "@/components/Reports";
import Settings from "@/components/Settings";
import Home from "@/components/Home";
import SlackAuth from "@/components/SlackAuth";
import SlackAdd from "@/components/SlackAdd";
import Signout from "@/components/Signout";
import DashboardHome from "@/components/DashboardHome";
import Seven from "@/components/reports/Seven";
import Fourteen from "@/components/reports/Fourteen";
import Thirty from "@/components/reports/Thirty";
import Admin from "@/components/Admin";
import AdminSetting from "@/components/AdminSetting";
import User from "@/components/admin/User";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home,
    },
    {
      path: "/dashboard",
      name: "Dashboard",
      component: Dashboard,
      beforeEnter: (to, from, next) => {
        if (localStorage.slacktoken) {
          next();
        } else {
          next({ path: "/" });
        }
      },
      children: [
        {
          path: "/dashboard",
          name: "DashboardHome",
          component: DashboardHome,
          children: [
            {
              path: "/dashboard",
              name: "SignIn",
              component: Signin,
            },
            {
              path: "/signedin",
              name: "SignOut",
              component: Signout,
            },
          ],
        },
        {
          path: "/reports",
          redirect: "/reports/seven",
          name: "Reports",
          component: Reports,
          children: [
            {
              path: "/reports/seven",
              name: "Seven",
              component: Seven,
            },
            {
              path: "/reports/fourteen",
              name: "fourteen",
              component: Fourteen,
            },
            {
              path: "/reports/thirty",
              name: "Thirty",
              component: Thirty,
            },
          ],
        },
        {
          path: "/activity",
          name: "Activity",
          component: Activity,
        },
        {
          path: "/settings",
          name: "Settings",
          component: Settings,
        },
        {
          path: "/admin",
          name: "Admin",
          component: Admin,
        },
        {
          path: "/admin/users/:id",
          name: "User",
          component: User,
        },
        {
          path: "/admin/settings",
          name: "AdminSetting",
          component: AdminSetting,
        },
      ],
    },
    {
      path: "/slackauth",
      name: "SlackAuth",
      component: SlackAuth,
    },
    {
      path: "/slackadd",
      name: "SlackAdd",
      component: SlackAdd,
    },
    {
      path: "*",
      redirect: "/",
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js